<app-sidenav (onPulsar1)="onPadre1($event)" (onPulsarDes)="onPadreDes($event)"></app-sidenav>
<br>
<section class="contenido">
  <router-otlet></router-otlet>
</section>
